import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import TimelineIcon from '@mui/icons-material/Timeline';
import InsightsIcon from '@mui/icons-material/Insights';

const IntroContent = () => {
    return (
      <Box sx={{ textAlign: 'center', pt: 16, pb: 12 }}>  {/* Increased top padding */}
        <Container maxWidth="lg">
          <Box sx={{ mb: 12 }}>
            <Typography variant="h1" 
              sx={{ 
                fontSize: { xs: '2.5rem', md: '4rem' },
                fontWeight: 700,
                mb: 3,
                textAlign: 'center',
                width: '100%',
                background: 'linear-gradient(45deg, #2C5282 30%, #4299E1 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
              The WhyLine™: 5 Whys Strategy Framework
            </Typography>
            <Typography variant="h2" 
              sx={{ 
                fontSize: { xs: '1.5rem', md: '2rem' },
                color: '#dedede',
                mb: 6
              }}>
              Transform Problems into Strategic Solutions
            </Typography>
          </Box>

          {/* Benefits Grid with gradient backgrounds */}
          <Grid container spacing={4} sx={{ mb: 12 }}>
            <Grid item xs={12} md={4}>
              <Paper elevation={0} sx={{ 
                p: 4, 
                height: '100%', 
                background: 'linear-gradient(135deg, #EBF8FF 0%, #BEE3F8 100%)',
                color: '#2D3748'
              }}>
                <AutoGraphIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Deep Problem Analysis
                </Typography>
                <Typography color="text.secondary">
                  Dig beyond surface-level issues to discover fundamental causes
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={0} sx={{ 
                p: 4, 
                height: '100%', 
                background: 'linear-gradient(135deg, #E6F6FF 0%, #BAE6FD 100%)',
                color: '#2D3748'
              }}>
                <TimelineIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Strategic Insights
                </Typography>
                <Typography color="text.secondary">
                  Generate actionable strategies based on root cause analysis
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={0} sx={{ 
                p: 4, 
                height: '100%', 
                background: 'linear-gradient(135deg, #E1F0FF 0%, #A6D4FA 100%)',
                color: '#2D3748'
              }}>
                <InsightsIcon sx={{ fontSize: 40, color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" sx={{ mb: 2 }}>
                  AI-Powered Playbook
                </Typography>
                <Typography color="text.secondary">
                  Receive a customized action plan with clear next steps
                </Typography>
              </Paper>
            </Grid>
          </Grid>

          {/* How It Works with increased spacing */}
          <Box sx={{ mb: 12 }}>
            <Typography variant="h3" sx={{ 
              mb: 6,
              color: '#dedede'
            }}>
              How It Works
            </Typography>
            <Grid container spacing={4}>
              {[
                'Input your business context',
                'Answer the 5 Whys questions',
                'Get your strategic playbook'
              ].map((step, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Box sx={{ 
                    p: 4, 
                    borderRadius: 2,
                    background: 'linear-gradient(135deg, #E6F6FF 0%, #BAE6FD 100%)',
                    color: '#2D3748'
                  }}>
                    <Typography 
                      variant="h2" 
                      sx={{ 
                        color: 'primary.main',
                        fontWeight: 700,
                        mb: 1
                      }}>
                      {index + 1}
                    </Typography>
                    <Typography>{step}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>
    );
};
export default IntroContent;